var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 26.1589C51.5 38.7645 42.4664 49.2444 30.5625 51.408V34.2204H36.1207H36.5503L36.615 33.7958L37.7677 26.2342L37.8554 25.6589H37.2734H30.5625V21.2541C30.5625 20.2907 30.7978 19.4015 31.3492 18.7598C31.8885 18.1321 32.7944 17.6668 34.2997 17.6668H37.5781H38.0781V17.1668V10.7292V10.3078L37.6627 10.2364L37.5781 10.7292C37.6627 10.2364 37.6627 10.2364 37.6626 10.2364L37.6624 10.2364L37.6619 10.2363L37.6599 10.236L37.6528 10.2348L37.6261 10.2303C37.6027 10.2264 37.5684 10.2207 37.524 10.2136C37.4352 10.1993 37.3058 10.1791 37.1419 10.1548C36.8142 10.1063 36.348 10.0417 35.7922 9.97712C34.6828 9.84824 33.2067 9.71832 31.7581 9.71832C28.6868 9.71832 26.0926 10.6567 24.2659 12.4962C22.4392 14.3358 21.4375 17.0188 21.4375 20.3958V25.6589H15.3359H14.8359V26.1589V33.7204V34.2204H15.3359H21.4375V51.408C9.53356 49.2444 0.5 38.7645 0.5 26.1589C0.5 11.985 11.9196 0.5 26 0.5C40.0804 0.5 51.5 11.985 51.5 26.1589Z",
    fill: "white",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.bb33e85c9fba98fb9fb3475d308b3bc6.svg";
export { ForwardRef as ReactComponent };